import React from 'react';

export const SectionTitle = ({title}) => {
  return (
    <h3 className="border-b pl-4 mb-3 text-sm uppercase font-semibold pb-2 pt-2">{title}</h3>
  );
};
